export default import.meta.ROLLDOWN_FILE_URL_sLVUX2k34Tp3hZhWBSKPlg